import { getValueReduxUtil } from '../../../../redux'
import { PLAN_KEY } from '../../constants'

function getLoggedAtPlanUtil (plan) {
  return getValueReduxUtil(
    plan, PLAN_KEY.LOGGED_AT
  )
}

export default getLoggedAtPlanUtil
